






























































































































import Vue from 'vue';

export default Vue.extend({
  props: ['projectsData'],

  methods: {
    showProject(project) {
      this.$emit('projectShow', project);
    },
    setPositionY() {
      this.$emit('getPositionY', window.scrollY);
    },
    getSize(): number {
      return 12;
    },
    getQuarterSize(): number {
      return this.getSize() / 4;
    },
    getHalfSize(): number {
      return this.getSize() / 2;
    },
    getFullSize(): number {
      return this.getSize();
    },
  },
  computed: {
    // need annotation
    projectsRowDataFirst(): Array<{}> {
      return Object.values(this.projectsData).filter(
        (project: any) => project.index <= this.getQuarterSize()
      );
    },
    projectsRowData0(): Array<{}> {
      return Object.values(this.projectsData).filter(
        (project: any) =>
          project.index > this.getQuarterSize() &&
          project.index <= this.getHalfSize()
      );
    },
    projectsRowData1(): Array<{}> {
      return Object.values(this.projectsData).filter(
        (project: any) =>
          project.index > this.getHalfSize() &&
          project.index <= this.getHalfSize() + this.getQuarterSize()
      );
    },
    projectsRowData(): Array<{}> {
      return Object.values(this.projectsData).filter(
        (project: any) =>
          project.index > this.getHalfSize() + this.getQuarterSize()
      );
    },
  },
  data() {
    console.log('projectsData', this.projectsData);
    return {
      // projectQuarter: this.getQuarterSize(),
      // projectSplit: this.getHalfSize(),
      // projectsLength: this.getFullSize(),
      positionY: 0,
    };
  },
});
